module.exports = __webpack_public_path__ + "img/corona.dd9030ab.png";